import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import WarningDialog from './plugins/warning-dialog/warning-dialog';
import ConfirmDialog from './plugins/confirm-dialog/confirm-dialog';
import Autocomplete from './components/Autocomplete.vue';
import { permissionsMixin } from './permissions';

// css
import './scss/app.scss';

Vue.config.productionTip = false;

const mixin = {
  data() {
    return {
      isDrawerOpen: window.innerWidth > 600,
      anyOption: '- Any -',
    };
  },
  filters: {
    startCase(str) {
      return _.startCase(str);
    },
    dateAtTime(iso) {
      return iso ? moment(iso)
        .format('M/D/YYYY [at] h:mm A') : 'N/A';
    },
    date(iso) {
      return iso ? moment(iso)
        .format('M/D/YYYY') : 'N/A';
    },
    time(iso) {
      return moment(iso)
        .format('h:mm A');
    },
    daysUntilDate(iso) {
      const now = moment();
      const date = moment(iso);
      return Math.ceil(date.diff(now, 'days', true));
    },
    parseJson(json) {
      return JSON.parse(json);
    },
  },
  computed: {
    drawerWidth() {
      const width = window.innerWidth < 600
        ? window.innerWidth - 40
        : 250;

      return `${width}px`;
    },
  },
  methods: {
    goToCallLog() {
      this.$router.push({ name: 'CallLogPage' });
    },
    goBack() {
      this.$router.go(-1);
    },
    getCall(CallID) {
      return this.$store.dispatch('getCall', { params: { CallID } });
    },
    goToUsersTable() {
      this.$router.push({ name: 'UsersTablePage' });
    },
    getUser(UserID) {
      return this.$store.dispatch('getUser', { params: { UserID } });
    },
    goToCustomersTable() {
      this.$router.push({ name: 'CustomersTablePage' });
    },
    getCustomer(CustomerID) {
      return this.$store.dispatch('getCustomer', { params: { CustomerID } });
    },
    objectDiff(object, base) {
      const changes = (object, base) => _.transform(object, (result, value, key) => {
        if (!_.isEqual(value, base[key])) {
          result[key] = (_.isObject(value)
            && _.isObject(base[key]))
            ? changes(value, base[key])
            : value;
        }
      });

      const diff = changes(object, base);

      return diff;
    },
  },
};

Vue.use(WarningDialog);
Vue.use(ConfirmDialog);
Vue.component('Autocomplete', Autocomplete);
Vue.mixin(mixin);
Vue.mixin(permissionsMixin);

const app = new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');

store.$app = app;
